
<div>
    <div class="modal-header modalHeaderDefault" style="margin-bottom: 10px;">
      <h6 class="modal-title">{{ "EncounterListPage.status" | translate }} </h6>
      <span aria-label="Close" class="close" (click)="onNoClick()">
        <mat-icon matTooltip="{{ 'inventory.close' | translate }}"
          >clear</mat-icon
        >
      </span>
    </div>
  
 <mat-form-field  
          class="fieldBox"
          appearance="outline">
            <mat-label>{{ "EncounterListPage.status" | translate }} </mat-label>
            <mat-select [(ngModel)]="Option" name="first" required>
              <mat-option *ngFor="let status of Status" [value]="status.code">
                {{ status.desc }}
              </mat-option>
            </mat-select>
          </mat-form-field>
         
 <!--   <mat-form-field
             style="padding-top: 10px; padding-bottom: 3px"
             class="fieldBox"
              appearance="outline" >
        <mat-label>
          {{ "Reason" }}
        </mat-label>
        <mat-select [required]="true" [(ngModel)]="Reason" [required]="true" placeholder="{{ 'inventory.selectReason' | translate }}">
          <mat-option *ngFor="let reason of Reasons" [value]="reason">
            {{reason.desc}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <mat-form-field  class="fieldBox mt-15" appearance="outline">
        <mat-label> {{ "EncounterListPage.remarks" | translate }}  </mat-label>
        <input matInput placeholder="Remarks" [(ngModel)]="Note" name = "remarks" pattern="[a-zA-Z0-9]+">
      </mat-form-field>
      
    </div>
      <div class="modal-footer mt-15">
        <button
        mat-flat-button
        class="btnGreen" color="primary"
        matTooltip="Confirm" 
        (click)="SaveRemarks('yes')">
        <mat-icon>check</mat-icon>
      </button>
      &nbsp;&nbsp;

        <button
          mat-flat-button
          (click)="onNoClick()"
          class="btnRed"
          color="primary"
          matTooltip="Cancel" 
        >
        <mat-icon>clear</mat-icon>
      
        </button>
        
        </div>
        
    
  